export default __webpack_public_path__ + "static/media/dashboard.9acc3cd8.svg";